
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rakeback",
      function () {
        return require("private-next-pages/rakeback/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rakeback"])
      });
    }
  